import {
  KoForm,
  KoFormBuilder,
  KoInput,
  KoSelect
} from 'packages';
import { useState } from 'react';
import { CHANNEL_TYPES } from '../../constants';

function AlertChannelCrud({ form, handleFinish }) {
  const [channelType, setChannelType] = useState(form.getFieldValue('type') || null);

  const TypeWidget = ({ value, onChange }) => (
    <KoSelect
      value={value}
      onChange={(val) => { onChange(val); setChannelType(val); }}
      placeholder='Select channel type'
      options={CHANNEL_TYPES}
    />
  );

  const baseFields = [
    { key: 'name', label: 'Channel Name', colSpan: 2, widget: KoInput, required: true, widgetProps: { placeholder: 'e.g. Team Slack' } },
    { key: 'type', label: 'Channel Type', colSpan: 2, widget: TypeWidget, forwardRef: true, required: true }
  ];

  const conditionalFields = [];
  if (channelType === 'email') {
    conditionalFields.push({
      key: 'recipients', label: 'Email Recipients', colSpan: 4,
      widget: KoInput, widgetProps: { placeholder: 'team@company.com, ops@company.com' }
    });
  } else if (channelType === 'slack') {
    conditionalFields.push({
      key: 'webhookUrl', label: 'Slack Webhook URL', colSpan: 4,
      widget: KoInput, widgetProps: { placeholder: 'https://hooks.slack.com/services/...' }
    });
  } else if (channelType === 'webhook') {
    conditionalFields.push(
      { key: 'url', label: 'Webhook URL', colSpan: 4, widget: KoInput, widgetProps: { placeholder: 'https://...' } },
      { key: 'headers', label: 'Headers (JSON)', colSpan: 4, widget: KoInput.TextArea, widgetProps: { rows: 3, placeholder: '{"Authorization": "Bearer ..."}' } }
    );
  } else if (channelType === 'pagerduty') {
    conditionalFields.push({
      key: 'integrationKey', label: 'PagerDuty Integration Key', colSpan: 4,
      widget: KoInput, widgetProps: { placeholder: 'Integration key from PagerDuty service' }
    });
  }

  const meta = {
    columns: 4,
    formItemLayout: null,
    colon: true,
    fields: [...baseFields, ...conditionalFields]
  };

  return (
    <KoForm form={form} layout='vertical' onFinish={handleFinish}>
      <KoFormBuilder form={form} meta={meta} />
    </KoForm>
  );
}

export default AlertChannelCrud;
